import { Banner } from "baseui/banner";
import { GetObjectUrl } from "../../../utils/navigationService";
import { TWeatherForecast } from "./types";
import { useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";

const WrongConfig: React.FC<TWeatherForecast> = (props) => {

    const configUrl = `${GetObjectUrl(props.resourceGroupId, props.id)}?defaultView=configuration`;
    const nav = useNavigate();

    const action = {
        label: "Set now",
        onClick: () => { nav(configUrl) },
    };
    return (<Banner 
        action={undefined}
        title={<FormattedMessage id="WeaterForecast.WrongConfig" defaultMessage={'Longitude & Latitude not configured'}></FormattedMessage>}
        kind='warning'>
        <FormattedMessage id="WeaterForecast.WrongConfigInfo" defaultMessage={'Set longitude and latitude to use this app'}></FormattedMessage>
    </Banner>);
};

export default WrongConfig;